import { z } from 'zod';

/**
 * Country settings form, mirroring AdminCountrySettingsRequest: names up to
 * 100 characters, three-letter currency codes, VAT 0–100, an optional site
 * address, SMS or Email verification, Arabic or English by default, and a
 * reason for the audit log. Input type === output type.
 */
export const countrySettingsSchema = z.object({
  nameEn: z.string().trim().min(1, 'English name is required.').max(100),
  nameAr: z.string().trim().min(1, 'Arabic name is required.').max(100),
  currencyCode: z.string().length(3, 'Pick a currency.'),
  settlementCurrency: z.string(),
  vat: z
    .number({ message: 'Enter a VAT rate.' })
    .min(0, 'VAT is 0–100%.')
    .max(100, 'VAT is 0–100%.'),
  siteUrl: z
    .string()
    .trim()
    .max(255)
    .refine(
      (value) => value === '' || /^https?:\/\/\S+$/i.test(value),
      'Enter a full web address.',
    ),
  verificationMethod: z.enum(['SMS', 'Email']),
  defaultLocale: z.enum(['ar', 'en']),
  reason: z.string().trim().min(3, 'Give a reason (at least 3 characters).').max(500),
});

export type CountrySettingsValues = z.infer<typeof countrySettingsSchema>;
